function autocompleteEmails(httpClient) {
  return httpClient({
    url: '/email-autocomplete',
    method: 'GET',
  })
}

// control names the control whose result is being resent, so the backend can
// offer the lists belonging to that control's owner rather than the caller's.
function autocompleteEmailLists(query, httpClient, control = {}) {
  const params = new URLSearchParams({ q: query ?? '' })
  if (control.controlType) {
    params.set('controlType', control.controlType)
  }
  if (control.controlId) {
    params.set('controlId', control.controlId)
  }
  return httpClient({
    url: `/emails/lists/autocomplete?${params.toString()}`,
    method: 'GET',
  })
}

export default {
  autocompleteEmails,
  autocompleteEmailLists,
}
